namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogAdmFunkcniMistoSpisovyUzelResult extends GContentBase {
        result: Gordic.AdmIsl.Interface.GPresunFunkcniMistoSpisovyUzelDto;
        grid: JQuery<HTMLElement>

        prepareContent() {
            this.createActions();
            this.createMenuBar();
            this.createCommandBar();
            this.createGrid();
        }

        private createActions() {
            this.actions.addRange({
                actClose: {
                    caption: "jres:32131042",
                    run: () => {
                        this.close()
                    }
                },
                actDetailFunkcniMisto: {
                    caption: "jres:33000955", //RC 33000955 : Detail fun. místa
                    icon: "gi-user",
                    run: () => {
                        this.openFunkcniMisto();
                    }
                }
            })
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar(["actClose!"]))
        }

        private createMenuBar() {
            this.menuBar(this.actions.createBar(["actDetailFunkcniMisto*"]))
        }

        private createGrid() {
            let polozkyArray = this.result.polozky as any[];
            polozkyArray.forEach((item) => {
                item.result_txt = item.result == 0 ? "jres:33000243" : "jres:32000124";
            });
            let view: Gordic.Data.View = new Gordic.Data.View(polozkyArray, { key: ["ixs_fun"] })
            view.process({
                ac: new Gordic.Data.Grouping([{
                    defaultState: "open",
                    hash: (meta, rows) => {
                        return `jres:33000028: ${meta.data['result_txt']}`
                    }
                }])
            })

            this.grid = $("<div>").appendTo(this.element).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "ixs_fun_txt",
                        caption: "jres:32131054"
                    })
                    .addTextColumn({
                        name: "ixs_su_old_txt",
                        caption: "jres:33000943"
                    })
                    .addTextColumn({
                        name: "ixs_su_new_txt",
                        caption: "jres:33000944"
                    }),
                data: view,
                defaultAction: this.actions.actDetailFunkcniMisto,
                selection: (ev, ctx) => {
                    this.actions.actDetailFunkcniMisto?.update({ enabled: ctx.count > 0 })
                }
            })
        }

        private openFunkcniMisto() {
            const data = this.grid.ggrid("activeRow");
            this.dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmFunkcniMisto", {
                openDialog: true,
            }], {
                ID: "DetailAdmFunkcniMisto",
                newRecord: false,
                ixs_fun: data.ixs_fun
            }, "" , 1200, 800) //RC 33000956 : Výsledek přesunu funkčních míst na spisové uzly
        }
    }
}